import { Component, computed, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { SiIconComponent } from '@siemens/element-ng/icon';

@Component({
    selector: 'app-tab-directions',
    templateUrl: './tab-directions.component.html',
    styleUrls: ['./tab-directions.component.scss'],
    imports: [SiFormItemComponent, FormsModule, TranslatePipe, SiIconComponent]
})
export class TabDirectionsComponent {
    public readonly gps = input<string>('');
    public readonly geoLocation = computed<{ lat: number; lng: number } | null>(() => {
        const value = this.gps();
        if (!value) {
            return null;
        }
        const parts = value.split(' ');
        if (parts.length < 4) {
            return null;
        }

        const lat = Number(parts[1].slice(0, parts[1].length - 1));
        const lng = Number(parts[3]);
        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            return null;
        }

        return { lat, lng };
    });
    public readonly gpsLink = computed(() => {
        const location = this.geoLocation();
        if (!location) {
            return '';
        }
        return `geo:${location.lat},${location.lng};u=35`;
    });

    public readonly origin = signal('');
    public readonly showList = signal(false);
    public readonly travelMode = signal<'car' | 'bus'>('car');

    // The directions Tab is currently not used in the drawer, but it is kept for future use.
    // Here we should find a new library to get the directions to a location.
    // Previously we used the Google Maps API, but we should change to open source alternatives.
    public getDirections(mode?: 'car' | 'bus'): void {
        if (mode) {
            this.travelMode.set(mode);
        }
        if (this.origin()) {
            this.showList.set(true);
        }
    }
}
